export const personTypeConstants = {
  customer: "مشتری",
  personnel: "کارمند",
  seller: "فروشنده",
  provider: "تامین کننده",
};
